export default "__VITE_ASSET__90fefc08__"